import ServiceGraphQL from 'src/service/gql-service';
import { removeCompany } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const RemoveCompany = (id) => {
  const params = {
    query: removeCompany.QUERY,
    variables: {
      filter: {
        _id: id
      }
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
